import { cn } from '@cocoonspace/ui/lib/utils'

import { GoogleCalendarIcon } from '~/components/icons/google-calendar-icon'
import { useListIntegrations } from '~/domains/account/hooks/use-list-integrations.hook'
import { ConnectBtn } from '../connect-btn'
import {
	ProviderDescription,
	ProviderName,
	ProviderWrapper,
} from './provider-wrapper'

export const GoogleCalendar = ({
	dense = false,
	showDeleteButtons,
}: {
	dense?: boolean
	showDeleteButtons?: boolean
}) => {
	const { data: userIntegrations } = useListIntegrations()

	const hasGoogleCalendar = !!userIntegrations?.google?.connected

	return (
		<ProviderWrapper
			isActive={hasGoogleCalendar}
			dense={dense}
		>
			<ProviderDescription>
				<GoogleCalendarIcon className={cn('size-6', { 'size-4': dense })} />
				<ProviderName dense={dense}>Google Calendar</ProviderName>
			</ProviderDescription>

			<ConnectBtn
				provider='google'
				connected={hasGoogleCalendar}
				showDeleteButtons={showDeleteButtons}
			/>
		</ProviderWrapper>
	)
}
